import { action } from 'satcheljs';

export interface OnCopilotChatDrawerCollapsedStateMessage {
    targetWindow: Window;
}

// Dispatched when the Copilot Chat Drawer is collapsed
// Collapsed means specifically at minimum width for Copilot Chat Drawer
export const onCopilotChatDrawerCollapsedState: (
    targetWindow: Window
) => OnCopilotChatDrawerCollapsedStateMessage = action(
    'onCopilotChatDrawerCollapsedState',
    (targetWindow: Window): OnCopilotChatDrawerCollapsedStateMessage => ({
        targetWindow,
    })
);
